import { Activity, History, Radio, Users } from "lucide-react";
import { NavLink } from "react-router-dom";

const links = [
  { to: "/", label: "状态", icon: Radio, testId: "nav-status-link" },
  { to: "/performance", label: "绩效统计", icon: Activity, testId: "nav-performance-link" },
  { to: "/trade-history", label: "交易历史", icon: History, testId: "nav-trade-history-link" },
  { to: "/users", label: "用户管理", icon: Users, testId: "nav-users-link" },
];

export const DashboardShell = ({ children }) => (
  <div className="app-shell" data-testid="app-shell">
    <header className="topbar" data-testid="dashboard-header">
      <div className="brand" data-testid="dashboard-brand">
        <span className="brand-mark">TS</span>
        <span>交易审计台</span>
      </div>
      <nav className="nav" aria-label="主要导航" data-testid="primary-navigation">
        {links.map(({ to, label, icon: Icon, testId }) => (
          <NavLink key={to} to={to} end={to === "/"} data-testid={testId}
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}>
            <Icon size={15} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </header>
    <main className="page-shell">{children}</main>
  </div>
);